// ReviewManagement.tsx

import * as React from 'react';
import ReviewHistory from './Components/ReviewHistory/ReviewHistory';
import CustomMenu from '../../components/CustomMenu/CustomMenu';

/**
 * 審査管理ページコンポーネント
 * - カスタムメニュー内に審査履歴一覧を表示する
 */
export default function ReviewManagement() {
  return (
    <CustomMenu>
      <ReviewHistory />
    </CustomMenu>
  );
}
